import { IReportStatus } from 'generated/axios';
import { t } from 'i18next';

export const getReportStatus = (status: IReportStatus | undefined) => {
  switch (status) {
    case 'draft':
      return t('report.status.draft');
    case 'processed':
      return t('report.status.processed');
    case 'confirmed':
      return t('report.status.confirmed');
    case 'error':
      return t('report.status.error');
    default: //in case of new non-translated values
      return status ?? '';
  }
};
